export class ActivityInstitutionForm {
    constructor(
        public physicianName: string,
        public institutionName: string,
        public city: string,
        public state: string,
        public country?: string
    ) { }
}
